<template>
    <v-app id="inspire">

      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

          <v-container fluid fill-height>
                <v-row  >
                    <v-col md="4" lg="4" cols="12">
                        <v-row>
                            <v-col md="12" lg="12" cols="12">
<v-card color="#393E46">
    <v-card-title>
{{persona.nombre}} {{persona.apellidoPaterno}} {{persona.apellidoMaterno}}
    </v-card-title>
    <v-card-text>
<v-row align="center" justify="center">
    <v-col lg="12" md="12" cols="12"  >
<v-img width="200px" :src="persona.foto"></v-img>
    </v-col>
    <v-col lg="12" md="12" cols="12"  >
      {{persona.tipoDocumento.tipoDocumento}}:  {{persona.dni}}
    </v-col>
    <v-col lg="12" md="12" cols="12"  >
     <v-icon>fas fa-location-arrow</v-icon> {{persona.direccion}},{{persona.distrito.distrito}}-{{persona.distrito.ciudad.ciudadNombre}}-{{persona.distrito.ciudad.provincia.provincia}}-{{persona.distrito.ciudad.provincia.pais.pais}}
    </v-col>
    <v-col lg="12" md="12" cols="12"  >
        <v-icon>fas fa-envelope</v-icon>    {{persona.email}}
    </v-col>
    <v-col lg="12" md="12" cols="12"  >
        <v-icon>fas fa-phone-alt</v-icon>    {{persona.telefono}}
    </v-col>
    <v-col lg="12" md="12" cols="12"  >
        <v-icon>fas fa-calendar-alt</v-icon>    {{formatDate(persona.fechaNacimiento)}}
    </v-col>
</v-row>
        <v-row>
            <v-col>

            </v-col>
        </v-row>
    </v-card-text>
</v-card></v-col></v-row>
                    </v-col>
                    <v-col md="8" lg="8" cols="12">
                        <v-row>
                            <v-col md="12" lg="12" cols="12">
<v-card  color="#393E46">
    <v-card-title> Membresias</v-card-title>
    <v-card-text>
                        <v-data-table
                                :headers="headers"
                                :items="histfiesta"
                                sort-by="negocio"
                                sort-desc
                                class="elevation-1"
                                :search="search"
                                :loading="progr"
                                no-data-text="No hay datos disponibles para mostrar."
                                no-results-text="No hay resultados para la búsqueda."
                                loading-text="Cargando... Por favor espere."
                                style="background-color: #393E46;"
                        >
                            <template v-slot:no-data>
                                <p>No hay Datos</p>
                                <v-btn color="primary" @click="damePersona">Cargar de Nuevo</v-btn>
                            </template>
                          <template v-slot:[`item.fecha`]="{ item }">
                            {{formatDateTime(item.fecha)}}
                          </template>
                        </v-data-table></v-card-text></v-card></v-col>
                            <v-col v-if="cliente.eventos"  md="12" lg="12" cols="12">
                                <v-card  color="#393E46">
                                    <v-card-title>Tickets</v-card-title>
                                    <v-card-text>
                                        <v-data-table
                                                :headers="headersev"
                                                :items="histevents"
                                                sort-by="Evento"
                                                sort-desc
                                                class="elevation-1"
                                                :search="search2"
                                                :loading="progr"
                                                no-data-text="No hay datos disponibles para mostrar."
                                                no-results-text="No hay resultados para la búsqueda."
                                                loading-text="Cargando... Por favor espere."
                                                style="background-color: #393E46;"
                                        >
                                            <template v-slot:no-data>
                                                <p>No hay Datos</p>
                                                <v-btn color="primary" @click="damePersona">Cargar de Nuevo</v-btn>
                                            </template>
                                          <template v-slot:[`item.fecha`]="{ item }">
                                            {{formatDateTime(item.fecha)}}
                                          </template>
                                        </v-data-table></v-card-text></v-card></v-col>
                            <v-col md="12" lg="12" cols="12">
                                <v-card  color="#393E46">
                                    <v-card-title>Modificaciones</v-card-title>
                                    <v-card-text>

                                        <v-data-table
                                                :headers="headermodf"
                                                :items="histmodifc"
                                                sort-by="Usuario"
                                                sort-desc
                                                class="elevation-1"
                                                :search="search3"
                                                :loading="progr"
                                                no-data-text="No hay datos disponibles para mostrar."
                                                no-results-text="No hay resultados para la búsqueda."
                                                loading-text="Cargando... Por favor espere."
                                                style="background-color: #393E46;"
                                        >

                                            <template v-slot:no-data>
                                                <p>No hay Datos</p>
                                                <v-btn color="primary" @click="damePersona">Cargar de Nuevo</v-btn>
                                            </template>
                                          <template v-slot:[`item.fechaCambio`]="{ item }">
                                                      {{formatDateTime(item.fechaCambio)}}
                                          </template>

                                        </v-data-table>

                                    </v-card-text></v-card></v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <leftmenu :abreviado="abreviado" />
              <v-overlay :value="overlay">
                <v-img
                    src="@/assets/loadtunay.gif"

                />
              </v-overlay>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
    import { mapGetters } from "vuex";
    import leftmenu from '../../general/leftmenu';
    import axios from 'axios';
    import moment from "moment";
    import firebase from 'firebase/compat/app';
    import Cabecerabaja from "@/components/general/cabecerabaja";

    export default {
      title: 'Ver Socio | Tunay Mi acceso de bolsillo',

      components: {
        Cabecerabaja,
            leftmenu,
        },
        data: () => ({
            drawer: null,
            idpersona: 0,
            progr: true,
          token:'',
            alertborrador: false,
            overlay:false,
            alertnuevo: false,
            alerteditar: false,
          abreviado:'NN',
            dialog: false,
            dialogdelete: false,
            date: new Date().toISOString().substr(0, 10),
            menu1: false,
            persona: {
                id: 0,
              nombre: '',
              apellidoPaterno: '',
              apellidoMaterno: '',
                dni : '',
              fechaNacimiento: '',
              foto: '',
              direccion: '',
              email: '',
                telefono : ''
            },
            histfiesta: [],
            histevents: [],
            histmodifc: [],
            search: '',
            search2: '',
            search3: '',
            headers: [
                { text: 'Discoteca', value: 'tipoCarnetSocio.temporada.negocio.negocioNombre', sortable: false },
                { text: 'Membresia', value: 'tipoMembresia.tipoMembresiaNombre'},
                { text: 'Carnet', value: 'tipoCarnetSocio.tipoCarnetNombre' },
                { text: 'Inscripción', value: 'fecha' },
                { text: 'Estado', value: 'estadoCarnet.estadoCarnet' },
                { text: 'Tipo de Pago', value: 'tipoPago.tipoPago' },
            ],
            headersev: [
                { text: 'Evento', value: 'eventoDTO.eventoNombre', sortable: false },
                { text: 'Estado', value: 'estadoEventoDTO.estadoEventoNombre'},
                { text: 'Tipo de Pago', value: 'tipoPagoDTO.tipoPagoNombre' },
                { text: 'Banco', value: 'bancoDTO.bancoNombre' },
                { text: 'Nro Operación', value: 'nrooper' },
                { text: 'Fecha de Inscripción', value: 'fecha' },
            ],
            headermodf: [
                { text: 'Modificador', value: 'usuarioDTO.usuarioNombre', sortable: false },
                { text: 'Cambio Realizado', value: 'cambio'},
                { text: 'Fecha de Cambio', value: 'fechaCambio' }
            ]
        }),
        mounted (){
            this.idpersona =  this.$route.params.idpersona
          if (this.usuario.id === undefined){
            this.overlay = true
            firebase
                .auth()
                .onAuthStateChanged(user => {
                  if(user){
                    this.overlay = false
                    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                    this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
                    this.damePersona();

                  }else{
                    this.overlay = false
                    this.$router.push({ path: '/' });
                  }
                })

          }else{
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
            this.damePersona();
          }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            "$route.params.idpersona"(value) {
                console.log(value);
                this.idpersona =  this.$route.params.idpersona
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.damePersona();
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
            },
        },
        methods : {
          formatDate(value) {
            return moment(value).locale('es-pe').format("DD MMMM YYYY")
          },
          formatDateTime(value) {
            return moment(value).locale('es-pe').format("DD MMMM YYYY h:mm:ss a")
          },
            damePersona(){
                this.progr = true;
              var bodyFormData = new FormData();
              this.overlay = true;
              bodyFormData.append('tag', this.idpersona);
              bodyFormData.append('clienteId', this.cliente.id);
                axios
                    .post('personas/versocio',bodyFormData,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.persona = response.data.persona;
                      this.histfiesta = response.data.membresias;
                      this.histevents = response.data.tickets;
                      this.histmodifc = response.data.modificaciones;
                       this.progr = false;
                       this.overlay = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                      this.progr = false;
                    });
            },
          close () {
                this.dialog = false;
                this.dialogdelete = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

        },
        computed: {
            // map `this.user` to `this.$store.getters.user`

            computedDateFormatted () {
                return this.formatDate(this.date)
            },
            ...mapGetters({
                user: "user",
                usuario: "usuario",
                cliente: "cliente"
            })
        }
    };
</script>
